import Vue from 'vue';

export default class StoricoInviiReportFornitorePage extends Vue {

}